import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		group: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
		},
		// The browser's own spinners are hidden (Chrome draws them on hover, Firefox always), so only the
		// Figma's steppers show. Scoped here so other number fields keep theirs.
		number: {
			"& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
				WebkitAppearance: "none",
				margin: 0,
			},
			"& input[type=number]": {
				MozAppearance: "textfield",
			},
		},
		stepper: {
			display: "flex",
			flexDirection: "column",
		},
		step: {
			padding: 0,
			color: theme.palette.secondary.main,
		},
		groupTitle: {
			fontSize: 16,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
